import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import { getAdmins } from '../../../redux/actions/SuperAdmin.action';

const ActiveAdminList = () => {
    const dispatch = useDispatch();
    const admins = useSelector((state) => state.superAdmin);
    const plans = useSelector((state) => state.plan);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedPlan, setSelectedPlan] = useState('');

    const totalCount = admins?.getAdmins?.data?.totalCount || 0;

    useEffect(() => {
        const params = {
            page: currentPage,
            limit: rowsPerPage,
            search: searchQuery,
            isActive: true,
            planId: selectedPlan
        };
        dispatch(getAdmins(params));
    }, [dispatch, currentPage, rowsPerPage, searchQuery, selectedPlan]);

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const handlePageChange = (selected) => {
        setCurrentPage(selected.selected + 1);
    };

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1);
    };

    return (
        <>
            <div className="mt-[100px] d-flex justify-content-between">
                <div className="d-flex items-center gap-3">
                    <Form.Group>
                        <Form.Select
                            value={selectedPlan}
                            onChange={(e) => setSelectedPlan(e.target.value)}
                            className="shadow-none focus:!border-theme-dark"
                        >
                            <option value="">All Plans</option>
                            {plans?.getPlans?.data?.data?.map((plan) => (
                                <option key={plan._id} value={plan._id}>
                                    {plan.planName}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </div>
                <div className="d-flex items-center gap-3">
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
                        <IoSearchOutline />
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearch}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                </div>
            </div>

            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <div className='d-flex align-items-center gap-2'>
                        <h3 className='fw-bold mb-0'>Active Admin List</h3>
                    </div>
                    <div className='d-flex align-items-center gap-4'>
                        <span className='bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm fw-bold'>
                            Total : <span className="text-theme-dark">{totalCount}</span>
                        </span>
                        <div className='text-gray-800 fw-bold'>
                            Rows per page:
                        </div>
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="px-3 py-1 border rounded-md focus:outline-none focus:border-theme-dark fw-bold text-gray-800"
                        >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>
                </div>

                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Name</Th>
                                <Th>Email</Th>
                                <Th>Phone</Th>
                                <Th>Plan</Th>
                                <Th>Create By</Th>
                                <Th>Start Date</Th>
                                <Th>End Date</Th>
                                <Th>Status</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {admins?.getAdmins?.data?.AuthData && admins?.getAdmins?.data?.AuthData.length > 0 ? (
                                admins?.getAdmins?.data?.AuthData.map((admin) => (
                                    <Tr key={admin._id}>
                                        <Td>{admin.name}</Td>
                                        <Td>{admin.email}</Td>
                                        <Td>{admin.phoneNumber}</Td>
                                        <Td>{admin.planId?.planName || 'No Plan'}</Td>
                                        <Td>{admin.admin_created_by?.name || ''}</Td>
                                        <Td>{new Date(admin.startDate).toLocaleDateString('en-GB')}</Td>
                                        <Td>{new Date(admin.endDate).toLocaleDateString('en-GB')}</Td>
                                        <Td>
                                            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800`}>
                                                Active
                                            </span>
                                        </Td>
                                    </Tr>
                                ))
                            ) : (
                                <Tr>
                                    <Td colSpan={7} textAlign='center'>No Active Admins Found</Td>
                                </Tr>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageChange}
                pageRangeDisplayed={5}
                pageCount={Math.ceil(totalCount / rowsPerPage)}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />
        </>
    );
};

export default ActiveAdminList;